{
  "description": "Descripción",
  "parties": "Partes",
  "amount": "Monto",
  "method": "Método",
  "date": "Fecha",
  "debit": "Debito",
  "credit": "Credito",
  "accounted-for": "Contabilizado",
  "observations": "Observaciones",
  "options": "Opciones",
  "delete": "Eliminar",
  "disbursements": "Desembolsos",
  "receipts": "Recibos",
  "ledger": "Registro Contable",
  "add-entry": "Agregar entrada",
  "unaccounted": "No contabilizado",
  "rest": "Restante",
  "titleparty": "Eliminar Partida de Desembolso",
  "confirmationMessageParty": "¿Estás seguro de que deseas eliminar esta partida asociada a la entrada de desembolso? Esta acción no se puede deshacer.",
  "titleDisbursement": "Eliminar Entrada de Desembolso",
  "confirmationMessageDisbursement": "¿Estás seguro de que deseas eliminar esta entrada de desembolso? Esta acción no se puede deshacer.",
  "titleAccounted": "Eliminar Entrada Contabilizada",
  "confirmationMessageAccounted": "¿Estás seguro de que deseas eliminar esta entrada contabilizada asociada a la entrada de desembolso? Esta acción no se puede deshacer.",
  "createLinkEntry": "Agregar Entrada",
  "editLinkEntry": "Editar entrada",
  "close": "Cerrar",
  "add": "Agregar",
  "total": "Total",
  "already-accounted": "Contabilizado",
  "filter": "Buscar",
  "error-missing-letter-number": "Esta entrada debe tener tanto una letra como un número para ser contabilizada",
  "error-letter-j": "Las entradas con letra J no pueden seleccionarse para contabilización",
  "empty-entry": "No hay entradas registradas",
  "no-entries-found": "No encontramos ninguna entrada para contabilizar",
  "error-max-amount": "El valor no puede ser mayor que",
  "error-amount": "Debe ser un numero positivo",
  "required": "Requerido",
  "error-date": "Debe ser una fecha válida",
  "edit": "Editar",
  "netfunded": "Fondos Netos Desembolsados",
  "balance": "Saldo",
  "balanced": "Balanceado",
  "disburse": "Desembolsar",
  "underfunded": "Insuficientemente financiado",
  "posted": "Contabilizado",
  "true": "Verdadero",
  "false": "Falso",
  "titlePosted": "Cambiar estado de contabilizado",
  "confirmationMessagePosted": "¿Estás seguro de que deseas cambiar el estado de esta entrada? Esta acción actualizará el valor de contabilizado",
  "agree": "Aceptar",
  "amount_override": "Monto Ajustado",
  "proceeds": "Producto",
  "filter-field-description": "Descripción",
  "filter-field-name": "Nombre",
  "filter-field-role": "Rol",
  "filter-field-disabled": "Filtro deshabilitado, mostrando todas las entradas",
  "filter-helper-text": "Use el filtro a continuación para buscar por:",
  "createLinkEntry-disbursement": "Agregar Desembolso",
  "createLinkEntry-receipt": "Agregar Recibo",
  "createLinkEntry-netfunded": "Agregar Entrada de Fondos Netos"
}
